import { Box, Flex, Image } from "@chakra-ui/react"
import { Link } from "@tanstack/react-router"

import mezoLogoRed from "#/assets/mezo-logo-inline-red.svg"

type MenuNavItem = {
  title: string
  url: string
}

type MenuSectionProps = {
  menuNav?: MenuNavItem[]
}

export default function LandingMenu({ menuNav = [] }: MenuSectionProps) {
  return (
    <>
      <style>{`
            .mobile-menu {
              display: none;
            }
            .social-icon:hover {
                opacity: 0.5;
            }
            .open {
              background: transparent;
              width: 50px;
              height: 50px;
              display: block;
              border-radius: 2px;
              cursor: pointer;
              position: relative;
              top: 50%;
              right: 0;
              z-index: 999!important;
            }

            .open:before {
              content: "";
              background-color: black;
              width: 30px;
              height: 3px;
              display: block;
              position: relative;
              border-radius: 20px;
              top: -5px;
              transform: rotate(0deg);
              transition: all 0.3s ease;
            }

            .open:after {
              content: "";
              background-color: black;
              width: 30px;
              height: 3px;
              display: block;
              border-radius: 20px;
              position: relative;
              top: 5px;
              transform: rotate(0deg);
              transition: all 0.3s ease;
            }

            .menuOpen {
              width: 30px;
              height: 20px;
              display: block;
              cursor: pointer;
              float: right;
              z-index: 999;
            }

            .menuOpen:hover .open:before {
              top: -9px;
            }

            .menuOpen:hover .open:after {
              top: 5px;
            }

            .menu {
              position: fixed;
              width: 100vw;
              height: 100vh;
              top: 0;
              left: 0;
              background: white;
              z-index: 2;
            }

            .menu label {
              width: 30px;
              height: 30px;
              position: absolute;
              right: 20px;
              top: 20px;
              background-size: 100%;
              cursor: pointer;
            }

            .menu .menuContent {
              height: 80vh;
              display: flex;
              align-items: center;
              font-size: 48px;
              text-align: left;
              padding: 120px 30px;
              max-width: 980px;
              margin: auto;
            }

            .menu .nav-link {
              font-size: 72px;
              line-height: 80px;
              width: 100%;
              display: block;
              margin: 0px 0;
              text-transform: none;
              color: black;
            }

            .menu .nav-link:hover {
              border: none;
              opacity: 0.5;
            }

            .menuEffects {
              opacity: 0;
              visibility: hidden;
              transition: opacity 0.5s, visibility 0.5s;
            }

            .menuEffects ul {
              transform: translateY(0%);
              transition: all 0.5s;
            }

            #menuToggle {
              visibility: hidden;
            }

            #menuToggle:checked ~ .menuEffects {
              opacity: 1;
              visibility: visible;
              transition: opacity 0.5s;
            }

            #menuToggle:checked ~ .menuEffects ul {
              opacity: 1;
            }

            #menuToggle:checked ~ .menuOpen .open {
              background-color: transparent;
            }

            #menuToggle:checked ~ .menuOpen .open:before {
              content: "";
              background-color: black;
              transform: rotate(45deg);
              position: absolute;
              top: 0;
              right: 0;
              left: 0;
              z-index: 1;
            }

            #menuToggle:checked ~ .menuOpen .open:after {
              content: "";
              background-color: black;
              transform: rotate(-45deg);
              position: relative;
              top: 0;
              right: 0;
              z-index: 1;
            }

            #menuToggle:not(:checked) ~ .menuEffects ul {
              transform: translateY(-30%);
            }

            @media screen and (max-width: 780px) {
              .mobile-menu {
                display: block;
                width: 50px;
                height: 50px;
                position: fixed;
                right: 0;
                top: 0;
                margin-top: 30px;
                margin-right: 20px;
                z-index: 999;
              }
              .menu .nav-link {
                font-size: 50px;
                line-height: 60px;
                letter-spacing: -1px;
              }
              .social-icon {
                width: 40px;
              }
            }

        `}</style>
      <Box>
        <Flex>
          <div className="mobile-menu">
            <input type="checkbox" id="menuToggle" />
            {/*  eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label htmlFor="menuToggle" className="menuOpen">
              <div className="open" />
            </label>

            <div className="menu menuEffects">
              <Link to="/" style={{ position: "relative", zIndex: 10 }}>
                <Image src={mezoLogoRed} alt="Mezo Logo" p="30px 25px" />
              </Link>
              {/*  eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label htmlFor="menuToggle" />
              <div className="menuContent">
                {menuNav.length > 0 && (
                  <Flex display="block" justifyContent="center">
                    {menuNav.map((item) => (
                      <Link
                        to={item.url}
                        className="nav-link"
                        data-attr={`mobile-menu-${item.title.toLowerCase()}`}
                      >
                        {item.title}
                      </Link>
                    ))}
                  </Flex>
                )}
              </div>
            </div>
          </div>
        </Flex>
      </Box>
    </>
  )
}
